import React, { Component } from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { FontAwesomeIcon } from '../modules';
import FontUtils from '../utils/FontUtils';

export class ButtonList extends Component {
  constructor (props) {
    super(props);
  }

  componentWillMount () {
    FontUtils.importFontAwesome();
  }

  render () {
    const {children} = this.props;
    return (
      <View
        style={styles.buttonList}>
        {children}
      </View>
    );
  }
}

export class LeftButton extends Component {

  constructor (props) {
    super(props);
  }

  componentWillMount () {
    FontUtils.importFontAwesome();
  }

  render () {
    const {title, image, icon, component, disabled, style, onClick} = this.props;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        disabled={disabled}
        style={[{marginLeft: 10}, style]}
        onPress={onClick}>
        {title && <Text style={styles.titleText}>
          {title}
        </Text>}
        {image && <Image source={image}/>}
        {icon && <FontAwesomeIcon
          name={icon.name}
          size={icon.size}
          color={icon.color}/>}
        {component}
      </TouchableOpacity>
    );
  }
}

export class RightButton extends Component {

  constructor (props) {
    super(props);
  }

  componentWillMount () {
    FontUtils.importFontAwesome();
  }

  render () {
    const {title, image, icon, component, disabled, style, onClick} = this.props;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        disabled={disabled}
        style={[{marginRight: 10}, style]}
        onPress={onClick}>
        {title && <Text style={styles.titleText}>
          {title}
        </Text>}
        {image && <Image source={image}/>}
        {icon && <FontAwesomeIcon
          name={icon.name}
          size={icon.size}
          color={icon.color}/>}
        {component}
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  buttonList: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '400',
    backgroundColor: 'transparent',
  },
});



// WEBPACK FOOTER //
// ./src/navigation/NavigationButtons.js